import { render, staticRenderFns } from "./CheckPersonas.vue?vue&type=template&id=a2fd6b06&scoped=true&"
import script from "./CheckPersonas.vue?vue&type=script&lang=js&"
export * from "./CheckPersonas.vue?vue&type=script&lang=js&"
import style0 from "./CheckPersonas.vue?vue&type=style&index=0&id=a2fd6b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fd6b06",
  null
  
)

export default component.exports